import { IHideActionProps } from "../DocumentTableInterfaces";
import "../css/DocumentTable.css";
import { ExcludeSerialNumberState } from "../../../../routing/RoutingStates";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
export default function HideAction({
  document,
  isAdvancedUser,
}: IHideActionProps) {
  const navigate = useNavigate();
  const handleNavigationClick = (row: any) => {
    const excludeSerialNumberState: ExcludeSerialNumberState = {
      document: document,
    };
    navigate("ExcludeSerialNumber", {
      state: { excludeSerialNumberState },
    });
  };

  return (
    <Button id={`mainPageKey-hide-${document.documentReference}`}
            title="Serial Number Linking"
            onClick={() => handleNavigationClick(document)}
            className="pointer btn-xs ms-1 btn-light" 
            >
      <FontAwesomeIcon icon={faEyeSlash} />
    </Button>
  );
}
